import * as React from 'react'
import { cn } from '@/lib/utils'

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  name?: string | null
  // Optional photo URL (feedback #79); falls back to initials when absent.
  src?: string | null
}

function initialsFromName(name?: string | null): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/).slice(0, 2)
  return parts.map(p => p[0]?.toUpperCase() ?? '').join('') || '?'
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, name, src, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 text-sm font-semibold text-primary',
        className
      )}
      {...props}
    >
      {children ??
        (src ? (
          <img
            src={src}
            alt={name ?? ''}
            className='h-full w-full object-cover'
          />
        ) : (
          initialsFromName(name)
        ))}
    </div>
  )
)
Avatar.displayName = 'Avatar'

// eslint-disable-next-line react-refresh/only-export-components
export { Avatar, initialsFromName }
